enum WorkspaceProjectMetricMeasurementProof {
  'Proof per unit of measurement' = 'Proof per unit of measurement',
  'Proof per measurement point' = 'Proof per measurement point',
}

export default WorkspaceProjectMetricMeasurementProof
